import { useEffect, useRef, useState } from "react";

import ThumbImg from "../../assets/images/conversations/blank.png";
// 008.webp
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";
import FacebookIcon from "../../assets/icons/conversations/facebook.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";
import TwitterIcon  from "../../assets/icons/conversations/twitter.svg";

/* ─────────────────────────────────────────────
   PREFIX: ec2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .ec2-page {
    background: #1A1A1A;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .ec2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .ec2-hero { padding-top: 60px; padding-bottom: 60px; }
  .ec2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .ec2-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .ec2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ec2-hero__title.ec2-visible { opacity: 1; transform: translateY(0); }

  /* social share buttons */
  .ec2-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .ec2-hero__social.ec2-visible { opacity: 1; transform: translateY(0); }
  .ec2-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .ec2-hero__social a:hover { opacity: 0.85; }
  .ec2-hero__social a.fb { background: #3B5998; }
  .ec2-hero__social a.li { background: #0077B5; }
  .ec2-hero__social a.tw { background: #1DA1F2; }
  .ec2-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .ec2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .ec2-hero__spotify.ec2-visible { opacity: 1; transform: translateY(0); }
  .ec2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .ec2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .ec2-hero__right.ec2-visible { opacity: 1; transform: translateY(0); }

  .ec2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .ec2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .ec2-yt-thumb:hover img { opacity: 0.85; }
  .ec2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .ec2-yt-thumb__play img { width: 40px; height: 44px; }
  .ec2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .ec2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .ec2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ec2-body.ec2-visible { opacity: 1; transform: translateY(0); }
  .ec2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .ec2-body__para:last-child { margin-bottom: 0; }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .ec2-inner { padding-left: 32px; padding-right: 32px; }
    .ec2-hero { padding-top: 32px; padding-bottom: 48px; }
    .ec2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .ec2-hero__title { font-size: 24px; }
    .ec2-hero__left { gap: 16px; }
    .ec2-hero__social { gap: 10px; }
    .ec2-hero__social a { gap: 10px; font-size: 12px; padding: 10px 12px; }
    .ec2-body__para { font-size: 14px; margin-bottom: 12px; }
    .ec2-body { padding-bottom: 48px; }
    .ec2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .ec2-inner { padding-left: 16px; padding-right: 16px; }
    .ec2-hero { padding-top: 51px; padding-bottom: 30px; }
    .ec2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .ec2-hero__left { gap: 30px; }
    .ec2-hero__title { font-size: 30px; }
    .ec2-hero__social { gap: 11px; }
    .ec2-hero__social a { gap: 10px; font-size: 15px; padding: 10px 14px; }
    .ec2-body__para { font-size: 16px; margin-bottom: 10px; }
    .ec2-body { padding-bottom: 30px; }
    .ec2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ec2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP08_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="ec2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 08 EV Consumer"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="ec2-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 08 EV Consumer thumbnail" />
      <div className="ec2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="ec2-hero">
      <div className="ec2-inner">
        <div className="ec2-hero__grid">
          <div className="ec2-hero__left">
            <div ref={titleRef} className="ec2-hero__title">
              EP 08 | Candid conversation with a "Significant" EV Consumer on his 1500km adventure
            </div>
            <div ref={socialRef} className="ec2-hero__social">
              <a href="https://www.facebook.com/sharer/sharer.php?u=" className="fb" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" /> Facebook
              </a>
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" /> Linked in
              </a>
              <a href="https://twitter.com/intent/tweet?url=" className="tw" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" /> Twitter
              </a>
            </div>
            <div ref={spotifyRef} className="ec2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/1MkQgaQO4me5IMzjdqnoTv?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 08 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="ec2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="ec2-body">
      <div className="ec2-inner">
        <p className="ec2-body__para">
          In today's episode, we decided to change track and feature a conversation with interesting insights from the perspective of an EV end user. Aakash drove his Tata Nexon 1500 km from Jaipur to Longewala and back and we go over the challenges and joys of an EV on long drives, including tow charging, issues with earthing for AC charging, and how ordinary drivers may be able to do long drives Atma Nirbhar with their own AC chargers today.
        </p>
      </div>
    </section>
  );
}

export default function Ep08EVConsumer() {
  return (
    <>
      <style>{CSS}</style>
      <div className="ec2-page">
        <HeroSection />
        <BodySection />
      </div>
    </>
  );
}